import moment from "moment";
import { clinicId, createdById } from "../../../../constants";
import {
  calculateAge,
  CalculatedAgeType,
} from "../../../../utilis/methods/dateMethods";
import {
  AddressType,
  ContactRollType,
  CountryType,
  LanguageType,
  MaritalStatusType,
  PatientRegistrationDataType,
  RaceType,
  RelationType,
  ReligionType,
  StateType,
  GroupingFamilyType,
} from "./RegistrationDataType";
import { groupingFamilyOptions } from "../fieldData";

export interface PatientMasterModel {
  patientMasterId: number | null;
  patientId: string | null;
  firstName: string;
  middleName: string | null;
  lastName: string;
  emiratesId: string | null;
  isVip: number;
  gender: "Male" | "Female";
  status: number;
  createdId: number;
  ip: string;
  clinicId: number;
  ageYears: string;
  ageMonths: string;
  ageDays: string;
  foDate: string;
  dob: string;
  maritalId: number | null;
  languageId: number | null;
  religionId: number | null;
  raceId: number | null;
  a28MsgStatus: number;
  priority: number | null;
  globalConsent: number | null;
  isEstablished: number | null;
  passportId: string | null;
  gccId: string | null;
  salutation: string | null;
  groupingFamily: string | null;
}

export interface AddressMasterModel {
  addressMasterId: number | null;
  patientMasterId: number | null;
  emailId: string | null;
  address: string | null;
  address1: string | null;
  address2: string | null;
  place: string;
  countryId: number;
  clinicCountryId: number;
  stateId: number;
  status: number;
  mobileNo: string;
  phoneNo: string | null;
  createdId: number;
  uploadFile: File | string | null;
  ip: string;
  addressTypeId: number | null;
  howKnow: null;
  clinicId: number;
  countryCode: number;
  faxNo: number | string | null;
}

export interface EmergencyContactModel {
  firstName: string | null;
  address2: string | null;
  address1: string | null;
  addressTypeId: number | null;
  clinicId: number | null;
  contactTypeId: number | null;
  createdId: number | null;
  ecNo: number | null;
  emergencyContactId: number | null;
  streetAddress: string | null;
  familyName: string | null;
  hl7MsgStatus: number | null;
  ip: string;
  mobileNo: string | null;
  patientMasterId: number | null;
  relationshipId: number | null;
  status: number | null;
}

export type EmergencyContactFormType = {
  contactType: ContactRollType | null;
  givenName: string | null;
  familyName: string | null;
  mobileNumber: string | null;
  addressType: AddressType | null;
  relation: RelationType | null;
  streetAddress: string | null;
  address: string | null;
  emergencyContactId: number | null;
};

export interface patientRegistrationModel {
  clinicId: number;
  patientMasterId: number | null;
  patientId: string | null;
  hl7MessageStatus: number;
  createdById: number;
  patientMasterDto: PatientMasterModel;
  addressMasterDto: AddressMasterModel;
  emergencyContactDto: EmergencyContactModel[] | null;
}

export type DocumentUploadType = {
  id?: number | string;
  file?: File | null;
  documentType?: string;
  fileName?: string;
  url?: string;
};

export type PatientRegistrationFormType = {
  patientMasterId: number | null;
  patientId: string | null;
  firstName: string;
  middleName: string | null;
  lastName: string;
  dob: string;
  age: number | string;
  id: string;
  idType: "Emirates" | "Passport" | "GCC" | "Qatar";
  gender: "Male" | "Female" | null;
  isVip: number;
  language: LanguageType | null | undefined;
  race: RaceType | null | undefined;
  address: string | null;
  addressType: AddressType | null | undefined;
  country: CountryType | null;
  state: StateType | null;
  nationality: CountryType | null;
  place: string;
  countryCode: CountryType;
  mobileNo: string;
  religion: ReligionType | null | undefined;
  maritalStatus: MaritalStatusType | null | undefined;
  groupingFamily: GroupingFamilyType | null;
  email: string | null;
  calcuatedAge: CalculatedAgeType;
  file: File | null;
  emergencyContact: EmergencyContactFormType[] | null;
  destination: string;
  documents: DocumentUploadType[];
};

export const extractPatientData = (
  data: PatientRegistrationFormType,
  patientData?: PatientRegistrationDataType
): patientRegistrationModel => {
  console.log("inside extractPatientData",data)
  return {
    clinicId,
    createdById: createdById as number,
    hl7MessageStatus: 0,
    patientMasterId: patientData?.addressMasterDto?.pmasterId || null,
    patientId: data.patientId,
    addressMasterDto: {
      address: data.address,
      address1: data.address,
      address2: data.address,
      addressTypeId: data.addressType?.id || null,
      countryId: data?.nationality?.id || 0,
      stateId: data?.state?.stateId || 0,
      place: data.place,
      countryCode: data.countryCode.id,
      emailId: data.email,
      mobileNo: data.mobileNo,
      addressMasterId: patientData?.addressMasterDto?.addressMasterId || null,
      clinicCountryId: data?.country?.id || 0,
      clinicId,
      createdId: Number(createdById),
      faxNo: null,
      howKnow: null,
      ip: "",
      patientMasterId: patientData?.addressMasterDto?.pmasterId || null,
      phoneNo: "",
      status: 1,
      uploadFile: data?.file || null,
    },
    patientMasterDto: {
      firstName: data.firstName,
      middleName: data.middleName,
      lastName: data.lastName,
      dob: data.dob,
      ageDays: String(data.calcuatedAge.fullAge.days),
      ageMonths: String(data.calcuatedAge.fullAge.months),
      ageYears: String(data.calcuatedAge.fullAge.years),
      emiratesId: data.idType == "Emirates" || data.idType == "Qatar" ? data.id : null,
      passportId: data.idType == "Passport" ? data.id : null,
      gccId: data.idType == "GCC" ? data.id : null,
      gender: data.gender as "Male" | "Female",
      isVip: data.isVip,
      a28MsgStatus: 0,
      clinicId,
      createdId: Number(createdById),
      foDate: moment().format("YYYY-MM-DD"),
      globalConsent: null,
      ip: "",
      isEstablished: 0,
      languageId: data?.language?.langId || null,
      maritalId: data?.maritalStatus?.id || null,
      patientId: patientData?.patientMasterDto.patientId || null,
      patientMasterId: patientData?.addressMasterDto?.pmasterId || null,
      priority: null,
      raceId: data.race?.raceId || null,
      religionId: data.religion?.religionId || null,
      salutation: null,
      status: 1,
      groupingFamily: data.groupingFamily?.name || null,
    },
    emergencyContactDto: null,
  };
};

// function base64ToFile(base64: string, fileName: string) {
//   const bstr = atob(base64);
//   let n = bstr.length;
//   const u8arr = new Uint8Array(n);
//   while (n--) {
//     u8arr[n] = bstr.charCodeAt(n);
//   }
//   const ext = fileName.split(".")[1] || "jpg";
//   return new File([u8arr], fileName || "patientimage.jpg", {
//     type: `image/${ext}`,
//   });
// }

export const extractFormData = (
  data: PatientRegistrationDataType
): PatientRegistrationFormType => {
  const calcuatedAge = calculateAge(data?.patientMasterDto?.dob || "");
  const {
    addressMasterDto: a,
    emergencyContactDto: e,
    // image,
    patientMasterDto: p,
  } = data;
  let idType: "Emirates" | "Passport" | "GCC" = "Emirates";
  let id: string = "";
  p.emiratesId && (id = p.emiratesId);
  p.gccId && (id = p.gccId);
  p.passportNum && (id = p.passportNum);
  p.emiratesId && (idType = "Emirates");
  p.passportNum && (idType = "Passport");
  p.gccId && (idType = "GCC");
  let file = null;
  const emergencyContact: EmergencyContactFormType[] = [];
  if (Boolean(e?.length)) {
    e?.forEach((con) => {
      emergencyContact.push({
        address: con.address1 || null,
        addressType: con.addressTypeId
          ? {
              addressType: con.addressTypeName || "",
              id: con.addressTypeId || 0,
            }
          : null,
        contactType: con.contactTypeId
          ? {
              contactrollId: con.contactTypeId || 0,
              contactrollName: con.contactTypeName || "",
            }
          : null,
        emergencyContactId: con.emgContactId,
        familyName: con.familyName,
        givenName: con.fullName,
        mobileNumber: con.mobileNumber,
        relation: con.relationId
          ? {
              relationId: con.relationId || 0,
              relationName: con.relationName || "",
            }
          : null,
        streetAddress: con.streetAddress,
      });
    });
  }
  // if (p.photoName && image) {
  //   file = base64ToFile(image, p.photoName);
  // }
  const groupingValue = p.groupingFamily ?? p.grouping;
  const groupingFamily = groupingValue
    ? groupingFamilyOptions.find(
        (option) =>
          option.name === groupingValue || option.id === groupingValue,
      ) ?? { id: 0, name: String(groupingValue) }
    : null;

  return {
    address: a?.address1 || null,
    addressType: {
      addressClinicId: a.clinicId,
      addressType: a.addressTypeName || "",
      code: "",
      id: a.addressTypeId || 0,
    },
    age: p.age,
    calcuatedAge,
    country:a.clinicCountryId ? {
      id: a.clinicCountryId || 0,
      countryName: a.clinicCountryName || "",
      countryCode: "",
      isoCode: "",
      nationality: "",
    } : null,
    countryCode: {
      id: a.countryCodeId || initialRegistrationData.countryCode.id,
      countryCode: a.countryCodeName || initialRegistrationData.countryCode.countryCode,
      countryName: "",
      isoCode: "",
      nationality: "",
    },
    dob: p.dob,
    destination: "Registered",
    documents: [],
    email: a.email,
    firstName: p.firstName,
    middleName: p.middleName || null,
    gender: p.gender,
    id,
    idType,
    isVip: p.isVip,
    language: {
      langId: p.languageId || 0,
      langName: p.languageName || "",
    },
    lastName: p.lastName,
    maritalStatus: {
      id: p.maritalId || 0,
      maritalStatus: p.maritalName || "",
    },
    groupingFamily,
    mobileNo: a.mobile || "",
    nationality: a.nationalityId
      ? {
          nationality: a.nationalityName || "",
          id: a.nationalityId || 0,
          countryCode: "",
          countryName: "",
          isoCode: "",
        }
      : null,
    patientId: p.patientId,
    patientMasterId: Number(p.id || "0"),
    place: a.city,
    race: {
      raceId: p.raceId || 0,
      raceName: p.raceName || "",
    },
    religion: {
      religionId: p.religionId || 0,
      religionName: p.religionName || "",
    },
    state: a.stateId ? {
      stateId: a.stateId || 0,
      stateName: a.stateName || "",
    } : null,
    file,
    emergencyContact: emergencyContact,
  };
};

export const initialRegistrationData: PatientRegistrationFormType = {
  patientMasterId: null,
  patientId: null,
  firstName: "",
  middleName: null,
  lastName: "",
  dob: "",
  age: "",
  id: "784-",
  idType: "Emirates",
  address: "",
  addressType: null,
  country: {
    id: 227,
    isoCode: "ARE",
    countryName: "United Arab Emirates",
    countryCode: "971",
    nationality: "Emirati",
  },
  state: {
    stateId: 5,
    stateName: "Ras Al Khaimah",
    stateStatus: 1,
    stateCode: "RAK",
    countryId: 227,
  },
  calcuatedAge: {
    fullAge: {
      years: 0,
      months: 0,
      days: 0,
    },
    ageType: "Y",
    age: 0,
  },
  countryCode: {
    id: 227,
    isoCode: "ARE",
    countryName: "United Arab Emirates",
    countryCode: "971",
    nationality: "Emirati",
  },
  email: "",
  place: "Ras Al Khaimah",
  gender: null,
  isVip: 0,
  language: null,
  maritalStatus: null,
  groupingFamily: null,
  mobileNo: "",
  nationality: null,
  religion: null,
  race: null,
  file: null,
  destination: "Registered",
  documents: [],
  emergencyContact: [
    {
      contactType: null,
      givenName: null,
      familyName: null,
      mobileNumber: null,
      addressType: null,
      relation: null,
      streetAddress: null,
      address: null,
      emergencyContactId: null,
    },
  ],
};
